module.exports = __webpack_public_path__ + "static/media/Dashboard.95f3882f.svg";